import React, { useEffect, useState } from "react";
import { DateRangeBarChart } from "../../Component/Analytics/DateRangeBarChart";
import AnalyticsDataService from "../../services/analytics";
import { DateTime } from "luxon";
import {
  Box,
  Select,
  VStack,
  HStack,
  Text,
  Input,
  SimpleGrid,
} from "@chakra-ui/react";
import { getFYMonths } from "../../helper/helper";
import { platformOptions, countTypeOptions } from "../../Config/graphfilter";
import { MultiSelect } from "react-multi-select-component";

export const AssessmentRecords = () => {
  const firstDayOfMonth = DateTime.now().startOf("month").toISODate();

  const yesterday = DateTime.now().minus({ days: 1 }).toISODate();

  const [platforms, setPlatforms] = useState<any[]>(["WEB", "APP"]);
  const [startDate, setStartDate] = useState(firstDayOfMonth);
  const [endDate, setEndDate] = useState(yesterday);

  const [countType, setCountType] = useState("daily");

  const [countData, setCountData] = useState<any>([]);

  const [monthlyCounts, setMonthlyCounts] = useState<any[]>([]);

  const calculateSum = (arr: any[]) => {
    return arr.reduce((sum: any, item: any) => sum + item.assessment, 0);
  };

  const fetchEhcGraphs = () => {
    AnalyticsDataService.getAssessmentCount(startDate, endDate, platforms)
      .then((res: any) => {
        if (countType === "daily") {
          const data = res.data.map((item: any) => {
            // const formatted: any = {
            //   date: item.date,
            // };

            // item.issues.forEach((issue: any) => {
            //   formatted[issue.name] = issue.count;
            // });

            // return formatted;

            return {
              date: item.date,
              assessment: item.dailyCounts,
            };
          });
          setCountData(data);
        } else {
          const data = res.data.map((item: any) => {
            return {
              date: item.date,
              assessment: item.totalCounts,
            };
          });
          setCountData(data);
        }
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  const fetchMonthlyCounts = async () => {
    const fyMonths = getFYMonths();

    const results = await Promise.all(
      fyMonths.map(async (m) => {
        try {
          const res = await AnalyticsDataService.getAssessmentCount(
            m.startDate,
            m.endDate,
            platforms
          );

          const data = res.data.map((item: any) => {
            return {
              date: item.date,
              assessment: item.dailyCounts,
            };
          });

          return { label: m.label, value: calculateSum(data) || 0 };
        } catch (err) {
          console.error("Error fetching count for", m.label, err);
          return { label: m.label, value: 0 };
        }
      })
    );
    setMonthlyCounts(results);
  };

  useEffect(() => {
    fetchEhcGraphs();
  }, [startDate, endDate, countType, platforms]);

  useEffect(() => {
    fetchMonthlyCounts();
  }, [platforms]);

  return (
    <>
      {/* <Box
        bg="#e98b90"
        color="white"
        fontWeight="bold"
        textAlign="center"
        textColor="black"
        py={4}
        px={6}
      >
        Assessment
      </Box> */}
      <Box px={6} py={0} maxW="100%" bg="gray.50">
        <VStack align="start" spacing={0}>
            <Box my={8}>
              <Text fontSize="lg" fontWeight="bold" mb={3}>
                Monthly Assessment Counts
              </Text>
              <SimpleGrid columns={{ base: 2, md: 8 }} spacing={2}>
                {monthlyCounts.map((m) => (
                  <Box
                    key={m.label}
                    p={2}
                    borderWidth="1px"
                    borderRadius="lg"
                    boxShadow="sm"
                    textAlign="center"
                    bg="white"
                  >
                    <Text fontSize="sm" color="gray.500">
                      {m.label}
                    </Text>
                    <Text fontSize="lg" fontWeight="bold" color="teal.600">
                      {m.value}
                    </Text>
                  </Box>
                ))}
              </SimpleGrid>
            </Box>
          <HStack spacing={8} align="center">
            <Text fontSize="lg" fontWeight="semibold">
              From
            </Text>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />

            <Text fontSize="lg" fontWeight="semibold">
              To
            </Text>
            <Input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              max={DateTime.now().toISODate()}
            />
            <Select
              placeholder="Select Count Type"
              value={countType}
              onChange={(e) => setCountType(e.target.value)}
            >
              {countTypeOptions.map((item: any, index: any) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </Select>

            <MultiSelect
              options={platformOptions}
              labelledBy="Select Platforms"
              value={platformOptions.filter((opt) =>
                platforms.includes(opt.value)
              )}
              onChange={(selected: any) =>
                setPlatforms(selected.map((opt: any) => opt.value))
              }
            />
          </HStack>

          <Box w="100%" mt={6}>
            <DateRangeBarChart
              data={countData}
              xKey="date"
              barKey="assessment"
              isSessionCount={false}
            />
          </Box>
        </VStack>
      </Box>
    </>
  );
};
